import { useState } from "react";
import { Stack } from "@mui/material";
import {
  FILE_NAME_LENGTH_LIMIT,
  FILE_SIZE_LIMIT_EXCEEDED,
  FILE_SIZE_LIMIT_WARNING,
  isValidUploadableFile,
} from "../../../services/mediaObjectService";
import { Dropzone } from "../../Dropzone/Dropzone";

type LegalbirdDropzoneProps = {
  files: File[];
  setFiles: Function;
  acceptedFiles?: Array<string>;
  key?: number;
};

export default function LegalbirdDropzone({ files, setFiles, acceptedFiles, key }: LegalbirdDropzoneProps) {
  const [error, setError] = useState<"fileNameFormat" | null>(null);

  const fileSize = files[0] ? files[0].size : 0;

  const handleChange = (files: File[]) => {
    for (const file of files) {
      if (!isValidUploadableFile(file.name)) {
        setError("fileNameFormat");
        setFiles([]);
        return;
      }
    }
    setError(null);
    setFiles(files);
  };

  const getErrorText = () => {
    switch (true) {
      case error === "fileNameFormat":
        return `Dateiname hat ein falsches Format. Bitte prüfen, dass der Dateiname nicht länger als ${FILE_NAME_LENGTH_LIMIT} Zeichen ist und keine Sonderzeichen, Leerzeichen oder Punkte vorhanden sind.`;
      case fileSize > FILE_SIZE_LIMIT_WARNING && fileSize < FILE_SIZE_LIMIT_EXCEEDED:
        return "Achtung: Die Datei ist über 10 MB groß. Wollen Sie diese trotzdem hochladen?";
      case fileSize >= FILE_SIZE_LIMIT_EXCEEDED:
        return "Achtung: Die Datei ist über 20 MB groß und kann nicht hochgeladen werden.";
      default:
        return null;
    }
  };

  return (
    <Stack
      sx={{
        gap: "1rem",
        padding: "1rem 0",
      }}
    >
      <Dropzone
        key={key}
        onChange={handleChange}
        filesLimit={1}
        dropzoneText={"Datei hierher ziehen oder Fläche anklicken"}
        maxFileSize={300000000}
        fileObjects={files}
        acceptedFiles={acceptedFiles}
        clearOnUnmount={true}
        error={getErrorText()}
      />
    </Stack>
  );
}
